import React from 'react';

const Footer = () => {
    return (
        <footer className='py-5'>
            <p className='text-review-hub-base-green font-light text-lg'>©Milhan Joardar Aumi, 2022.</p>
        </footer>
    );
};

export default Footer;